export const FETCH_REF_DOCTORS = "[RECEPTIONIST] FETCH_REF_DOCTORS";
export const FETCH_REF_DOCTORS_START = "[RECEPTIONIST] FETCH_REF_DOCTORS_START";
export const FETCH_REF_DOCTORS_SUCCESS = "[RECEPTIONIST] FETCH_REF_DOCTORS_SUCCESS";
export const FETCH_REF_DOCTORS_ERROR = "[RECEPTIONIST] FETCH_REF_DOCTORS_ERROR";
export const SET_REF_DOCTORS_PAGINATION = "SET_REF_DOCTORS_PAGINATION";


export const ADD_UPDATE_REF_DOCTOR = "[RECEPTIONIST] ADD_UPDATE_REF_DOCTOR";
export const ADD_UPDATE_REF_DOCTOR_START = "[RECEPTIONIST] ADD_UPDATE_REF_DOCTOR_START";
export const ADD_UPDATE_REF_DOCTOR_SUCCESS = "[RECEPTIONIST] ADD_UPDATE_REF_DOCTOR_SUCCESS";
export const ADD_UPDATE_REF_DOCTOR_ERROR = "[RECEPTIONIST] ADD_UPDATE_REF_DOCTOR_ERROR";

export const DELETE_REF_DOCTOR = "[RECEPTIONIST] DELETE_REF_DOCTOR";
export const DELETE_REF_DOCTOR_START = "[RECEPTIONIST] DELETE_REF_DOCTOR_START";
export const DELETE_REF_DOCTOR_SUCCESS = "[RECEPTIONIST] DELETE_REF_DOCTOR_SUCCESS";
export const DELETE_REF_DOCTOR_ERROR = "[RECEPTIONIST] DELETE_REF_DOCTOR_ERROR";


export const DELETE_PROVIDER_LOCATION = "[RECEPTIONIST] DELETE_PROVIDER_LOCATION";
export const DELETE_PROVIDER_LOCATION_START = "[RECEPTIONIST] DELETE_PROVIDER_LOCATION_START";
export const DELETE_PROVIDER_LOCATION_SUCCESS = "[RECEPTIONIST] DELETE_PROVIDER_LOCATION_SUCCESS";
export const DELETE_PROVIDER_LOCATION_ERROR = "[RECEPTIONIST] DELETE_PROVIDER_LOCATION_ERROR";

export const FETCH_ALL_REF_DOCTORS = "[RECEPTIONIST] FETCH_ALL_REF_DOCTORS";
export const FETCH_ALL_REF_DOCTORS_START = "[RECEPTIONIST] FETCH_ALL_REF_DOCTORS_START";
export const FETCH_ALL_REF_DOCTORS_SUCCESS = "[RECEPTIONIST] FETCH_ALL_REF_DOCTORS_SUCCESS";
export const FETCH_ALL_REF_DOCTORS_ERROR = "[RECEPTIONIST] FETCH_ALL_REF_DOCTORS_ERROR";


export const fetchRefDoctors = (payload) => {
    return {
        type: FETCH_REF_DOCTORS,
        payload
    }
}

export const addUpdateReferredDoctor = (doctor) => {
    return {
        type: ADD_UPDATE_REF_DOCTOR,
        payload: { doctor }
    }
}

export const deleteRefDoctor = (refDrId) => {
    return {
        type: DELETE_REF_DOCTOR,
        payload: refDrId
    }
}

export const deleteProviderLocation = (payload) => {
    return {
        type: DELETE_PROVIDER_LOCATION,
        payload
    }
}

export const fetchAllRefDoctors = () => {
    return {
        type: FETCH_ALL_REF_DOCTORS,
        payload: null
    }
}